import { put, takeEvery } from "redux-saga/effects";
import { setPageLoaderVisibility } from "../Actions";
import config from "./../../Config";
import apiCall from "./../../Services/api";
import { BLOG_MANAGEMENT_API } from "../../Services/apiUrls";
import * as actionTypes from "./../ActionTypes/blogManagement";
import { ToastNotifyError } from "../../Components/Toast";
// import { parseToJson } from "../../Utils/common";

function* fetchSinglePageData(actions: any) {
  try {
    yield put(setPageLoaderVisibility(true));
    const response = yield apiCall({
      method: "GET",
      url: `${config.base_url}${BLOG_MANAGEMENT_API.fetchBlogs}?${actions.data}`,
      parseToJson: true,
    });
    if (response && response.data?.status) {
      actions.callback && actions.callback(response.data.data, response.data?.status);
    }
    yield put(setPageLoaderVisibility(false));
  } catch (err) {
    yield put(setPageLoaderVisibility(false));
    ToastNotifyError("Error!");
  }
}

function* analyzeBlogPageById(actions: any) {
  try {
    yield put(setPageLoaderVisibility(true));
    const response = yield apiCall({
      method: "GET",
      url: `${config.base_url}${BLOG_MANAGEMENT_API.analyzeBlogPage}/${actions?.data?.pageId}`,
      parseToJson: true,
    });
    if (response && response.data?.status) {
      actions.callback && actions.callback(response.data.data, response.data?.status);
    }
    yield put(setPageLoaderVisibility(false));
  } catch (err) {
    yield put(setPageLoaderVisibility(false));
    ToastNotifyError("Error!");
  }
}

function* updateBlogPageStatus(actions: any) {
  try {
    yield put(setPageLoaderVisibility(true));
    const response = yield apiCall({
      method: "PUT",
      url: `${config.base_url}${BLOG_MANAGEMENT_API.updateBlogPageStatus}`,
      data: actions.data,
    });
    actions?.callback && actions?.callback(response?.data?.status, response?.data?.data);
    yield put(setPageLoaderVisibility(false));
  } catch (err) {
    yield put(setPageLoaderVisibility(false));
    ToastNotifyError("Unable to update page status!");
  }
}

export default function* root() {
  yield takeEvery(actionTypes.FETCH_BLOGS, fetchSinglePageData);
  yield takeEvery(actionTypes.ANALYZE_BLOG_PAGE, analyzeBlogPageById);
  yield takeEvery(actionTypes.UPDATE_BLOG_PAGE_STATUS, updateBlogPageStatus);
}
